<div class="card">
    <div class="card-content">
    
      <div class="details">
        <p class="title">{{title}}</p>
        <h2 class="value">{{count}}</h2>
      </div>
      <div class="icon-container">
        <img [src]="'/assets/icons/'+ icon" alt="Opportunities Icon" class="icon"/>
      </div>
    </div>
    <p>{{title}}</p>
  </div>
  